import * as A from "fp-ts/Array";
import { pipe } from "fp-ts/function";
import * as T from "fp-ts/Tree";
import { fromTraversable, Prism } from "monocle-ts";
import { generateId } from "./converters/generateRandomId";
const getModifier = (nodesAccessor, nodesSetter) => (root) => {
  class TraversalModifier {
    constructor(tree2, traversal) {
      this.tree = tree2;
      this.traversal = traversal;
    }
    filter(predicate) {
      return new TraversalModifier(
        this.tree,
        this.traversal.composePrism(Prism.fromPredicate(predicate))
      );
    }
    set(setter) {
      return pipe(
        // @ts-ignore $TsFixMe
        this.traversal.asFold().getAll(this.tree),
        A.map((node) => node._modId),
        foldTree(this.tree, setter)
      );
    }
  }
  const modifyById = (idsToSet, setter) => (modTreeNode) => {
    const { _modId, ...rest } = modTreeNode;
    const node = rest;
    return idsToSet.includes(_modId) ? setter(node) : node;
  };
  const mergeWith = (prefix) => (suffix) => [...prefix, ...suffix];
  const toArray = (node) => Array.isArray(node) ? node : A.of(node);
  const foldTree = (tree2, setter) => (idsToSet) => T.fold((root2, forest) => ({
    ...root2,
    ...nodesSetter(
      forest.reduce(
        (modifiedForest, node) => (
          // @ts-ignore $TsFixMe
          pipe(node, modifyById(idsToSet, setter), toArray, mergeWith(modifiedForest))
        ),
        []
      )
    )
  }))(tree2);
  const tree = T.unfoldTree(root, (node) => [
    { ...node, _modId: generateId() },
    nodesAccessor(node)
  ]);
  return new TraversalModifier(
    tree,
    // @ts-ignore $TsFixMe
    fromTraversable(T.tree)()
  );
};
export {
  getModifier
};
//# sourceMappingURL=modifier-infra.js.map
